import {
  ConvertBaseSettingsField,
  ConvertBaseSettingsStorageMixin,
} from "@/services/storage/storage-mixins/settings-mixins/convert-base-settings-storage-mixin";

export type DuetsSettingsField = ConvertBaseSettingsField | "models";

export class DuetsSettingsStorageMixin extends ConvertBaseSettingsStorageMixin<DuetsSettingsField> {
  protected setSettingsInternal(
    settings: any,
    value: any,
    field: DuetsSettingsField,
  ): void {
    if (field === "models") {
      if (!Array.isArray(settings[field])) {
        settings[field] = [];
      }

      settings[field] = value;
    } else {
      super.setSettingsInternal(settings, value, field);
    }
  }
}
